import { useEffect } from 'react';
import { useStoreInfoStore } from '../stores/useStoreInfoStore';

/**
 * 自定義 Hook：獲取當前認證用戶的店鋪資訊
 *
 * 用於管理後台頁面，自動調用 fetchMyStore() 獲取當前用戶的店鋪
 *
 * @returns {Object} 包含 storeId, storeInfo, isLoading
 *
 * @example
 * ```typescript
 * const { storeId, isLoading } = useCurrentStore();
 *
 * useEffect(() => {
 *   if (storeId) {
 *     fetchData(storeId);
 *   }
 * }, [storeId, fetchData]);
 * ```
 */
export const useCurrentStore = () => {
  const { storeInfo, fetchMyStore, isLoading } = useStoreInfoStore();

  // 組件載入時自動獲取當前用戶的店鋪
  useEffect(() => {
    fetchMyStore();
  }, [fetchMyStore]);

  return {
    /** 當前店鋪 ID（從認證用戶的 organizationId 獲取） */
    storeId: storeInfo?.id,
    /** 完整的店鋪資訊 */
    storeInfo,
    /** 載入狀態 */
    isLoading,
  };
};
